export default __webpack_public_path__ + "static/media/account_circle.0d08fe43.svg";